<div class="p-input-icon searcher">
  <div class="p-input-icon searcher__input">
    <i class="pi pi-search"></i>
    <input #searchInput type="text" pInputText [formControl]="searchControl" />
  </div>
</div>
